<!--banner-->
<div class="relative w-full h-[768px]">
    <!-- Desktop image -->
    <img src="/png/car-insurance-banner.png" alt="Background" class="w-full h-full object-cover hidden sm:block" />
    <!-- Mobile image -->
    <img src="/png/Full-Img.png" alt="Background Mobile" class="w-full h-full object-cover block sm:hidden" />
    <!-- Overlay text -->
    <div class="absolute max-w-[1200px] mx-auto w-full inset-0 flex flex-col items-start gap-4 justify-end sm:justify-center px-[20px] sm:gap-[25px] pb-[40px]">
        <h1
            class="text-[#1B1B1B] font-[Manrope] text-[32px] sm:text-[50px] font-bold leading-[40px] md:w-[536px] sm:leading-[76px] tracking-[-0.496px]">
            {{'Seamless Protection - Steadfast Wherever You Journey' | translate}}
        </h1>
        <p class="text-[#1B1B1B] font-[Manrope] text-[16px] sm:text-[20px] font-normal leading-normal max-w-[579px]">
            {{'Keep your journey safe from risks, Get comprehensive protection today' | translate}}
        </p>
        <div (click)="scrollToForm()" class="flex flex-col justify-center items-center p-4 gap-[8.986px] self-stretch 
                   rounded-[89.857px] bg-[#2AD189] hover:bg-[#A4FFD6] 
                   w-[200px] sm:w-[300px] max-w-[600px] 
                   cursor-pointer transition-colors duration-300">
            <a class="text-[16px] font-[manrope] text-[20px] not-italic font-bold leading-normal text-black">
                {{ 'REGISTER NOW' | translate }}
            </a>
        </div>
    </div>
</div>